import { addStyle } from 'dom-helper';
import iFrameBuilder from './iframe-builder';
import PathHelper from './path-helper';
import ENV from '../config/env';

import BRICK_VERSION from '../../../gwi-ads/iab_728x90_leaderboard/src/config/version';

export default class LeaderBoardIframeBuilder extends iFrameBuilder {
  static getFilePath() {
    const brickPath = ENV.adLeaderboardV1BrickPath;
    return `${PathHelper.getBrickPath(brickPath, BRICK_VERSION)}/${ENV.brickIndexFileName}`;
  }

  static styleHolder(holder) {
    addStyle(holder, {
      height: '90px',
      width: '728px',
    });

    return holder;
  }
}



// WEBPACK FOOTER //
// ./src/utils/leaderboard-iframe-builder.js